export default __webpack_public_path__ + "static/media/binMed.d8132540.svg";